export function useMask() {
  const appConfig = useAppConfig()
  const locale = appConfig.locale.code

  return {

    zip: { mask: '000 00' },

    phone: locale === 'sk' ? { mask: '[#]00000000000000', definitions: { '#': /[+]/ } } : { mask: '000 000 000' },

    positiveNumber: (digitsCount: number) => { return { mask: '0'.repeat(digitsCount) } },

    spz: { mask: /^[a-zA-Z0-9]{0,7}$/, prepare: (val: string) => val.toUpperCase() },

    price: { mask: Number, scale: 0, min: 0, thousandsSeparator: ' ' },

    age: { mask: Number, scale: 0, max: 99 },

    salary: { mask: Number, scale: 0, max: 9999999, thousandsSeparator: ' ' },

    moneyAmount: { mask: Number, scale: 2, thousandsSeparator: ' ', radix: '.' },

  }
}
